<template>
  <div>
  <SubMessageBox ref="message-box" v-if="checkVisibility('messagebox', step) && showSubscriptionMessage"/>
  <b-modal
    id="modal"
    centered
    no-close-on-backdrop
    hide-header
    hide-footer
    modal-class="bg-light vas-configurable-login-modal-component text-dark"
    :visible="isLoggingIn"
    @hidden="hideLogin"
    @shown="reset"
  >
    <template>
      <SubscriptionLoading :is-loading="isLoading" />
      <section v-if="checkVisibility('header',step)" class="header-section d-flex justify-content-center align-items-center">
        <div class="d-flex flex-row align-items-center">
          <img src="/logo.png" alt="xbuzzi-logo">
          <h5 class="modal-title ml-5">
            {{ configuration.header.titleText }}
          </h5>
        </div>
      </section>
      <section v-show="checkVisibility('phoneNumber', step)" class="align-items-center">

        <section class="w-100">
          <label>{{ $t(configuration.phoneNumber ? configuration.phoneNumber.titleText : '') }}</label>
          <b-form-input
            id="phoneNumber"
            v-model="phoneNumber"
            name="phoneNumber"
            type="tel"
            pattern="[0-9]"
            maxlength="15"
            v-mask="'###############'"
            class="pbone_mask"
            :placeholder="phoneNumberPlaceholder"
            />
            <b-alert v-show="phoneNumberInputError" fade show variant="danger">
              <small>{{ $t('security.phoneNumberIsInvalid') }}</small>
            </b-alert>
        </section>

      </section>
      <section v-if="checkVisibility('chooseOperator', step)">
        <h6 class="pb-1 w-100">{{ configuration.chooseOperator.titleText }}</h6>
        <b-form-group class="mb-0 text-center">
          <b-form-radio-group>
             <template v-for="optr in operators" >
               <div class="text-center d-inline-block mx-xxs-0">
                 <img :src="require(`@/assets/logos/${optr.logoName}`)" :alt="optr.name"
                 class="d-block mr-2"  width="50">
                 <b-form-radio v-model="operator" class="ml-4" :value="optr">
                 </b-form-radio>
               </div>
           </template>
          </b-form-radio-group>
        </b-form-group>
        <b-alert v-if="chooseOperatorError" fade show variant="danger">
           <small>{{ $t('security.operatorIsUnchoosen') }}</small>
        </b-alert>
      </section>
      <b-button
          v-if="checkVisibility('sendPhoneNumberBtn', step)"
          variant="primary"
          size="lg"
          class="w-100 mb-1"
          @click="checkRequiredPhoneNumber"
      >
        {{ configuration.sendPhoneNumberBtn.text }}
      </b-button>
      <PinInput :pin-input-text="configuration.pin? configuration.pin.titleText
          : ''"
v-show="checkVisibility('pin', step)" :pinLength="pinLength" :show-pin-error="pinError" ref="pinInput" />
      <section class="d-flex flex-column">
        <b-button
          v-if="checkVisibility('confirmPinBtn', step)"
          variant="success"
          size="lg"
          class="w-100"
          @click="checkPin"
        >
          {{ configuration.confirmPinBtn.text }}
        </b-button>
        <b-button 
          v-if="checkVisibility('resendPinBtn', step)"
          :disabled="resendBtn"
          variant="secondary"
          size="sm"
          class="w-100 mt-md-2 mt-xxs-3"
          @click="resendPin"
        >
          {{ configuration.resendPinBtn.text }}
        </b-button>
      </section>
      <section v-if="checkVisibility('reset', step)" class="d-flex align-self-start mb-3">
          <b-link class="text-secondary" @click="reset">
            <small>{{ $t('security.changePhoneNumber') }}</small>
          </b-link>
      </section>
      <small v-if="checkVisibility('terms', step)" class="terms d-flex align-self-start mb-3" v-html="configuration.terms.text"></small>
      <div class="line"/>
      <section v-if="checkVisibility('returnToPortal', step)" class="footer-section d-flex flex-row justify-content-end">
        <b-link class="mt-2 mb-2" @click="close">
          {{ configuration.returnToPortal.text }}
        </b-link>
      </section>
    </template>
  </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import utility from '@/utilities/utility'
import PhoneNumberInput from '@/components/PhoneNumberInput.vue'
import PinInput from '@/components/PinInputV2.vue'
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'
import SubMessageBox from "@/components/SubMessageBox.vue";

export default Vue.extend({
  name: 'VasConfigurableLoginModal',
  components: {
    PhoneNumberInput,
    PinInput,
    SubscriptionLoading,
    SubMessageBox
  },
  data () {
    return {
      isLoading: false,
      userUniqueIdentifier: '',
      userName: '',
      requestResult: {},
      operator: null,
      operators:[],
      isMultiPlanProviderCode: false,
      requestCode: null,
      checkBtn: false,
      resendBtn: true,
      time: 30,
      pinLength: 8,
      chooseOperatorError: null,
      step: 'phoneNumber',
      phoneNumber: null,
      phoneNumberInputError: null,
      showSubscriptionMessage: false,
      isFirstLogin: false,
      isSubFlow : false,
      pinError : false,
      isAlreadySubFlow: false,
      phoneNumberValidationRegex: null,
      planProviderCode: null,
      flowType: ''
    }
  },
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config',
      isLoggingIn: 'navigation/isLoggingIn'
    }),
    pinInput () {
      return this.$refs.pinInput
    },
    pin () {
      return this.$refs.pinInput.pin
    },
    configuration () {
      return this.designConfig.pages.vasLogin[this.step]
    },
    phoneNumberPlaceholder () {
      return this.configuration && this.configuration.phoneNumber && this.configuration.phoneNumber.placeholder
        ? this.configuration.phoneNumber.placeholder : this.$t('security.phoneNumberPlaceHolder')
    }

  },
  created(){
    if(Array.isArray(this.designConfig.userManagement.vas.planProviderCode)){
      this.isMultiPlanProviderCode = true
      this.operators = this.designConfig.userManagement.vas.planProviderCode.map((ppc) => {
        return ppc
      })
    }
  },
  methods: {
    ...mapActions({
      getUserStatus: 'subscription/getUserStatus',
      requestForSub: 'subscription/requestForSubscription',
      initSub: 'subscription/init',
      resendSub: 'subscription/resend',
      verify: 'subscription/verify',
      checkRequestStatus: 'subscription/checkRequestStatus',

      // initSub: 'subscription/initSub',
      // confirmSub: 'subscription/confirmSub',
      // getSubStatus: 'subscription/getSubStatus',

      authenticateVasUser: 'auth/authenticateVasUser',

      hideLogin: 'navigation/hideLogin',
      getValidations: 'subscription/getValidations',
      getTpayDigest: 'subscription/getTpayDigest'
    }),
    close () {
      this.$bvModal.hide('modal')
    },
    reset () {
      this.operator = null
      this.step = 'phoneNumber'
      this.isLoading = false
      this.requestResult = {}
      this.pinLength = 8
      this.phoneNumber = ''
      this.pinInput.pin = ''
      this.refCode = utility.createGUID()
      this.resendBtn = true
      this.checkBtn = false
      this.phoneNumberInputError = false
      this.chooseOperatorError =  false
      this.isSubFlow =  false
      this.isAlreadySubFlow =  false
      this.pinError = false
      this.planProviderCode = null
    },

    resendPin () {
      this.isLoading = true
      let ppc = null
      if (this.operator.code)
        ppc = this.operator.code
      else
        ppc = this.designConfig.userManagement.vas.planProviderCode
      let Payload = {
         RequesterServiceRefCode: this.requestCode,
         deviceType: 'None',
         userName: this.phoneNumber,
         planProviderCode: ppc,
         isEmail: false
      }
      this.resendSub(Payload).then(Response => {
        this.isLoading = false
        this.time = 30
        this.countDownTimer()
      })
    },
    countDownTimer () {
      if (this.time > 0) {
        this.resendBtn = true
        this.checkBtn = false
        setTimeout(() => {
          this.time -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.resendBtn = false
        this.checkBtn = true
      }
    },
    checkRequiredPhoneNumber() {
      if (this.isMultiPlanProviderCode && !this.operator)
        this.showInputError()
      else if (this.operator && this.operator.flowtype && this.operator.flowtype === 'cg')
        this.checkUserSubscription()
      else if (this.operator && this.operator.flowtype && this.operator.flowtype === 'digest') {
        this.getDigest()
      }
      else
        this.checkPhoneNumber()
    },
    checkPhoneNumber () {
      if (this.phoneNumber.length < 9) {
        this.isLoading = false
        this.phoneNumberInputError = true
      } else {
        this.phoneNumberInputError = false
        this.checkUserSubscription()
      }
    },
    checkUserSubscription () {
      this.isLoading = true
      let payload = {
        userName: this.phoneNumber
      }
      if (this.operator && this.operator.code)
        this.planProviderCode = this.operator.code
      else {
        this.planProviderCode = this.designConfig.userManagement.vas.planProviderCode
        this.flowType = this.designConfig.userManagement.vas.flowType
      }
      if(this.isMultiPlanProviderCode && !this.operator.code){
          this.isLoading = false
          this.showInputError()
          return
      } else {
        let validationsPayload = {
          planProviderCode: this.planProviderCode
        }
        this.getValidations(validationsPayload).then(validationResponse => {
          let validations = validationResponse.body.result
          this.checkValidtionPhoneNumber(validations)
          if(this.phoneNumberValidationRegex.test(this.phoneNumber)){
            this.getUserStatus(payload).then(response => {
              let result = response.body.result
              let userPlans = result.filter(r => r.state === 'Subscribe')
              if (userPlans.length > 0) {
                this.isAlreadySubFlow = true
                this.userUniqueIdentifier = userPlans[0].userUniqueIdentifier
                this.userName = userPlans[0].userName
                if (this.isMultiPlanProviderCode && !this.isSubFlow && this.operator.flowtype ===
                  'digest') {
                   this.sendToCredentialPage()
                } else {
                   this.login()
                }
              }
              this.processUnsubscribedUser()
            })
          } else if ((this.operator && this.operator.flowtype === 'cg') || this.flowType === 'cg') {
              this.processUnsubscribedUser()
          } else {
            this.isLoading = false
            this.phoneNumberInputError = true
          }
        })
      }
    },
    processUnsubscribedUser () {
      let payload = {
        planProviderCode: this.planProviderCode,
        pageCode: this.designConfig.userManagement.vas.pageCode,
        channel: 'Portal',
        channelName: window.location.hostname
      }

      this.requestForSub(payload).then(response => {
        let result = response.body.result
        this.requestResult = result
        this.requestCode = result.code
        if(result.pinLength > 0)
          this.pinLength = result.pinLength

        // TODO: Remove country code from payload
        if (result.subscriptionMethod === 'Otp') {
          let initPayload = {
            code: result.code,
            deviceType: 'None',
            userName: this.phoneNumber,
            isEmail: false
          }
          if (window.TPay && this.sessionToken) {
            initPayload.sessionToken = this.sessionToken
          }
          this.initSub(initPayload).then(initResponse => {
            this.countDownTimer()
            this.isLoading = false
            this.step = 'pin'
            this.isSubFlow = true
          })
        } else if (result.subscriptionMethod === 'CG' && !this.isAlreadySubFlow) {
          window.location.href = result.redirectUrl
        }
      })
    },
    checkPin () {
      if (this.pin.length < 4) {
        this.pinInput.showInputError()
        return
      }

      this.isLoading = true
      let confirmInput = {
        requesterServiceRefCode: this.requestResult.code,
        userInput: this.pin
      }

      this.verify(confirmInput)
        .then(response => {
          setTimeout(() => {
            this.checkConfirmStatus()
            this.isFirstLogin = true
          }, 2000)
        })
        .catch(err => {
          // TODO: Show an alert message about failure in send confirm request
          // Failed to send confirm request
          if (err) {
            this.reset()
          }
        })
    },
    checkConfirmStatus () {
      this.checkRequestStatus(this.requestResult.code).then(response => {
        let result = response.body.result

        if (result === 'Failed') {
          // TODO: Show an alert message about failure in sub request
          // Failed to confirm
          this.reset()
        }
        if (result === 'FailedVerification') {
          this.isLoading = false
          this.step = 'pin'
          this.isFirstLogin = false
          this.pinError = true
          return
        } else if (result === 'Finalized') {
          this.checkUserSubscription()
        } else {
          setTimeout(() => {
            this.checkConfirmStatus()
          }, 2000)
        }
      })
    },
    login () {
     this.authenticateVasUser(this.userName)
        .then(response => {
          let result = response.body.result

          if (result.resultType === 'Success') {
            this.isLoading = false
            if (this.isFirstLogin){
              this.step = 'successfullSub'
              this.showSubscriptionMessage = true
              setTimeout(() => {
                this.showSubscriptionMessage = false
              }, 5000)
            }
            this.close()
          } else if (result.resultType === 'InvalidUserNameOrPassword') {
            // Waiting for identity user to be created
            setTimeout(() => {
              this.login()
            }, 2000)
          } else {
            this.isLoading = false
          }
        })
        .catch(error => {
          this.isLoading = false
        })
        .finally(() => {})
    },
    sendToCredentialPage () {
      this.$router.push({name: 'sendCredential'})
      this.isLoading = false
      this.close()
    },
    showInputError () {
      this.chooseOperatorError = true
      setTimeout(() => {
        this.chooseOperatorError = false
      }, 5000)
    },
    checkVisibility(sec, step){
      return (this.designConfig.pages.vasLogin[step][sec] &&
        this.designConfig.pages.vasLogin[step][sec].isEnabled && !this.isLoading)
    },
    checkValidtionPhoneNumber(validations){
      var regExStr = '(^' + validations.countryCode + '[1-9]{1}[0-9]{' + (validations.numberLength - 1).toString() + '}$)|' +
      '(^0' + validations.countryCode + '[1-9]{1}[0-9]{' + (validations.numberLength - 1).toString() + '}$)|' +
      '(^00' + validations.countryCode + '[1-9]{1}[0-9]{' + (validations.numberLength - 1).toString() + '}$)|' +
      '(^0[1-9]{1}[0-9]{' + (validations.numberLength - 1).toString() + '}$)|' +
      '(^[1-9]{1}[0-9]{' + (validations.numberLength - 1).toString() + '}$)';
       this.phoneNumberValidationRegex = new RegExp(regExStr);
    },
    getDigest() {
      this.isLoading = true
      this.planProviderCode = this.operator.code
      this.getTpayDigest(this.planProviderCode)
        .then((response) => {
          this.getTpayScript(response.body.result)
        }, error => {
          console.log(error)
          this.isLoading = false 
        })
    },
    getTpayScript(payload) {
      let _this = this
      let date = payload.date
      let digest = payload.digest
      var setTpayScript = document.createElement('script')
      setTpayScript.src =
        `https://enrichment.tpay.me/idxml.ashx/js?date=${date}&digest=${digest}`
      setTpayScript.onload = function() {
        if (window.TPay) {
          _this.sessionToken = window.TPay.HeaderEnrichment.sessionToken()
        }
        _this.checkPhoneNumber()
      }
      setTpayScript.onerror = function() {
        _this.checkPhoneNumber()
      }
      document.getElementsByTagName('head')[0].appendChild(setTpayScript)
    }
  }
})
</script>
